import { Link } from 'react-router-dom';
import { Mail, MapPin, Github, Calendar } from 'lucide-react';
import { mockData } from '../mock';

export const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="logo-link" aria-label="We Dream Team — Accueil">
              <span className="brand-mark" aria-hidden="true">WDT</span>
              <span className="brand-name">We Dream Team</span>
            </Link>
            <p className="footer-tagline">
              Le web, l'IA et le cloud au service de votre activité. Basés à Lille, aux côtés des entreprises partout en France.
            </p>
          </div>

          <div>
            <h3 className="footer-col-title">Agence</h3>
            <ul className="footer-col-list">
              <li><Link to="/">Accueil</Link></li>
              <li><Link to="/about">À propos</Link></li>
              <li><Link to="/#realisations">Réalisations</Link></li>
              <li><Link to="/services">Tous nos services</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="footer-col-title">Expertises</h3>
            <ul className="footer-col-list">
              <li><Link to="/creation-web">Création de site internet</Link></li>
              <li><Link to="/services/ecommerce">E-commerce</Link></li>
              <li><Link to="/services/applications-web">Applications web</Link></li>
              <li><Link to="/services/seo">Référencement SEO</Link></li>
              <li><Link to="/intelligence-artificielle">Intelligence artificielle</Link></li>
              <li><Link to="/services/agents-ia">Agents IA</Link></li>
              <li><Link to="/cloud-devops">Cloud & DevOps</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="footer-col-title">Contact</h3>
            <ul className="footer-col-list">
              <li>
                <a href="mailto:faycal.zouaoui@wedreamteam.com" aria-label="Envoyer un email">
                  <Mail size={14} style={{ display: 'inline', marginRight: 6, verticalAlign: '-2px' }} />
                  faycal.zouaoui@wedreamteam.com
                </a>
              </li>
              <li>
                <a href={mockData.contact.bookingUrl} target="_blank" rel="noopener noreferrer">
                  <Calendar size={14} style={{ display: 'inline', marginRight: 6, verticalAlign: '-2px' }} />
                  Réserver un échange
                </a>
              </li>
              <li>
                <span style={{ color: 'var(--muted)' }}>
                  <MapPin size={14} style={{ display: 'inline', marginRight: 6, verticalAlign: '-2px' }} />
                  Lille, Hauts-de-France
                </span>
              </li>
              <li>
                <a href="https://github.com/zouaoui-faycal" target="_blank" rel="noopener noreferrer" aria-label="Profil GitHub">
                  <Github size={14} style={{ display: 'inline', marginRight: 6, verticalAlign: '-2px' }} />
                  GitHub
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-text">© {new Date().getFullYear()} We Dream Team. Tous droits réservés.</p>
          <span className="footer-meta">Fait avec soin à Lille · Hauts-de-France</span>
        </div>
      </div>
    </footer>
  );
};
